






















































































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import VueRouter from "vue-router";
import { Validator } from "vee-validate";
import { useThemeStore } from "@/shared/store/theme";

@Component({})
export default class PartnerTheme extends Vue {
  $router: VueRouter;
  $validator: Validator;

  themeStore = useThemeStore();

  @Prop() partnerId: string;
  selectedTheme = 0;
  submitDisabled = false;

  get isLoaded (): boolean {
    return this.themeStore.activeThemesIsLoaded;
  }

  created () {
    this.themeStore.getPartnerTheme(this.partnerId as any);
    this.themeStore.getActiveThemes();
  }

  mounted () {
    this.selectedTheme = this.themeStore.partnerTheme.themeId;
  }

  @Watch("themeStore.partnerTheme.themeId", { deep: true })
  onStoreValueChange (newValue) {
    this.selectedTheme = newValue;
  }

  saveTheme () {
    this.$validator.validateAll().then(isValid => {

      if (!isValid || this.submitDisabled) {
        return;
      }

      if (this.themeStore.partnerTheme.themeId === this.selectedTheme) {
        return;
      }

      this.submitDisabled = true;

      this.themeStore.savePartnerTheme({ partnerId: this.partnerId, themeId: this.selectedTheme })
        .finally(() => this.submitDisabled = false);
    });
  }

  get showDeleteButton (): boolean {
    return this.themeStore.partnerTheme.partnerThemeId && this.themeStore.partnerTheme.partnerThemeId !== 0;
  }

  deleteTheme () {
    this.themeStore.deletePartnerTheme(
      { partnerId: this.partnerId, partnerThemeId: this.themeStore.partnerTheme.partnerThemeId });
  }

  get primaryColor () {
    return this.themeStore.activeThemes.find(e => e.themeId === this.selectedTheme).primaryColor;
  }

  get secondaryColor () {
    return this.themeStore.activeThemes.find(e => e.themeId === this.selectedTheme).secondaryColor;
  }

  get tertiaryColor () {
    return this.themeStore.activeThemes.find(e => e.themeId === this.selectedTheme).tertiaryColor;
  }
  get primaryFontColor () {
    return this.themeStore.activeThemes.find(e => e.themeId === this.selectedTheme).primaryFontColor;
  }

  get secondaryFontColor () {
    return this.themeStore.activeThemes.find(e => e.themeId === this.selectedTheme).secondaryFontColor;
  }

  get tertiaryFontColor () {
    return this.themeStore.activeThemes.find(e => e.themeId === this.selectedTheme).tertiaryFontColor;
  }
  get buttonColor () {
    return this.themeStore.activeThemes.find(e => e.themeId === this.selectedTheme).isButtonColorPrimary
      ? this.primaryColor : this.secondaryColor;
  }

  get showColors () {
    return this.selectedTheme > 0;
  }

  @Watch("partnerId")
  fetchPartherTheme () {
    this.submitDisabled = false;
    this.themeStore.getPartnerTheme(this.partnerId);
  }
}
